import { iconBindings } from "../assets/icons/quadriWindows/iconBindings"

export const TaskTypeIcon = (props: { type: string }) => (
  <img src={iconBindings(props.type)} className="mb-n1 mr-1 ml-1" width="24" height="24" alt="a" />
)
